const colors = {
  //---- will be static in the web-app : no fields are needed in the dashboard
  ratingOkey: "#FFBC09",
  ratingGood: "#FF6600",
  red: "#FF0000",
  green: "#009900",
  blue: "#0066FF",
  darkRed: "#990000",
  black: "#000",
  orange: "#FF6600",
};

export default Object.freeze(colors);
